import { throttle } from './utils/throttle'

const defaultOpts = {
  ssrOrientation: null,
  mode: 'max'
}

class ViewportHeight {
  destroyed = false
  mounted = false
  listeners = []
  value = {
    portrait: 0,
    landscape: 0
  }
  opts: {
    ssrOrientation: 'portrait' | 'landscape'
  }
  throttledUpdate: any
  orientation: 'portrait' | 'landscape'

  constructor(opts = {}) {
    this.opts = { ...defaultOpts, ...opts }
    this.orientation = this.getOrientation()

    this.update()

    this.handleUpdate = this.handleUpdate.bind(this)
    this.throttledUpdate = throttle(this.handleUpdate, 100)
  }
  mount() {
    if (typeof window !== 'undefined') {
      window.addEventListener('resize', this.throttledUpdate)
      window.addEventListener('orientationchange', this.handleUpdate)
    }
    this.mounted = true
  }
  destroy() {
    if (typeof window !== 'undefined') {
      window.removeEventListener('resize', this.throttledUpdate)
      window.removeEventListener('orientationchange', this.handleUpdate)
    }
    this.mounted = false
  }

  getOrientation() {
    if (typeof window !== 'undefined') {
      if (window.innerHeight > window.innerWidth) {
        return 'portrait'
      }
      return 'landscape'
    }
    return this.opts.ssrOrientation
  }

  handleUpdate() {
    this.update()
  }

  listen(fn) {
    this.listeners.push(fn)
    if (this.mounted === false) {
      this.mount()
    }

    return () => {
      this.listeners = this.listeners.filter(listener => listener !== fn)
    }
  }

  emit() {
    const vh = this.getVh()
    const height = this.getHeight()
    this.listeners.forEach(listener => listener(vh, height, this.orientation))
  }

  getHeight() {
    if (this.orientation) {
      return this.value[this.orientation]
    }
    return 0
  }

  getVh() {
    if (this.orientation) {
      return this.value[this.orientation] / 100
    }
    return 0
  }

  update() {
    const currentOrientation = this.orientation
    this.orientation = this.getOrientation()

    if (this.orientation) {
      const currentValue = this.value[this.orientation]
      const newValue = window.innerHeight

      if (currentOrientation !== this.orientation) {
        if (newValue > currentValue) {
          this.value[this.orientation] = newValue
        }
        this.emit()
      } else if (newValue > currentValue) {
        this.value[this.orientation] = newValue
        this.emit()
      }
    }
  }
}

export function fixVhBug() {
  function handleUpdate(vh) {
    try {
      const html = document.getElementsByTagName('html')[0]
      html.style.setProperty('--dh-vh', `${vh}px`)
    } catch (error) {
      console.error(error)
    }
  }
  const vhListener = new ViewportHeight()
  vhListener.listen(handleUpdate)

  return vhListener
}
